export default {
  methods: {
    stopScroll (element) {
      var el = document.querySelector(element)
      el.addEventListener('touchmove', function (event) {
        event.preventDefault()
      }, false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/stopMaskingScroll.js